import { numberToCurrency } from '@admiin-com/ds-common';
import { Task } from '@admiin-com/ds-graphql';
import { WBFlex } from '@admiin-com/ds-web';
import { LineItemsView } from './LineItemsView';
import { TextFormField } from '../../../../components/TextFormField/TextFormField';
import { getTaskAmount } from '../../../../helpers/tasks';
export const AmountInfo = ({ task }: { task: Task }) => {
  return (
    <WBFlex flexDirection={'column'} gap={1}>
      <TextFormField
        label="Total"
        value={numberToCurrency(getTaskAmount(task))}
      />
      <LineItemsView task={task} />
    </WBFlex>
  );
};
